/* WebComponentHeader template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { HeaderComponent } from './cwc-header';

/**
 * Definition of  parameters that the template needs to work.
 */
interface HeaderTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: HeaderComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const HeaderTemplate: FunctionalComponent<HeaderTemplateProps> = () => (
  <Host>
    <slot />
  </Host>
);

export default HeaderTemplate;
